import { render, staticRenderFns } from "./SetPackageInAnalysisModal.vue?vue&type=template&id=2098e76c&scoped=true"
import script from "./SetPackageInAnalysisModal.vue?vue&type=script&lang=js"
export * from "./SetPackageInAnalysisModal.vue?vue&type=script&lang=js"
import style0 from "./SetPackageInAnalysisModal.vue?vue&type=style&index=0&id=2098e76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098e76c",
  null
  
)

export default component.exports